
var ZVWIM_KEY = "XNpMRQ";
// US waitlist list (VALHqF).
var ZVWIM_LIST = window.ZVShop.listId;
var ZVWIM_SOURCE = "us-shortform-why-zuvie";

function zvWimSay(t){ var m = document.getElementById('zvWimMsg'); if (m) m.textContent = t; }

function zvWimPost(path, body){
  return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + ZVWIM_KEY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
    body: JSON.stringify(body)
  }).then(function(r){
    if (r.status === 202 || r.ok) return true;
    throw new Error(path + ' ' + r.status);
  });
}

var zvWimBusy = false;
var zvWimDone = false;
function zvWimJoin(){
  if (zvWimBusy || zvWimDone) return;
  var email = document.getElementById('zvWimEmail').value.trim();
  var ageEl = document.getElementById('zvWimAge');
  var age = ageEl ? ageEl.value : '';
  var b = document.getElementById('zvWimJoin');
  zvWimSay('');
  if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0){ zvWimSay('Please enter a valid email address.'); return; }
  zvWimBusy = true;
  b.disabled = true; b.textContent = 'One moment…';

  var props = { signup_source: ZVWIM_SOURCE, market: 'US' };
  if (age) props.age_range = age;

  var subPayload = {
    data: {
      type: 'subscription',
      attributes: { profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } },
      relationships: { list: { data: { type: 'list', id: ZVWIM_LIST } } }
    }
  };
  // Both calls are required. /client/subscriptions/ sets consent and list membership but
  // writes NO properties onto a profile that already exists (proven 2026-08-11).
  // /client/profiles/ writes the fields on new and existing profiles alike.
  var profPayload = { data: { type: 'profile', attributes: { email: email, properties: props } } };

  // Custom event so signups are countable as a metric (same name as /pages/how-much-is-in-it).
  var evtPayload = {
    data: {
      type: 'event',
      attributes: {
        // Klaviyo deduplicates by profile + metric + unique_id.
        unique_id: 'zuvie-first-launch-waitlist-v1',
        properties: { age_range: age || 'not given', source: ZVWIM_SOURCE },
        metric: { data: { type: 'metric', attributes: { name: 'Joined US waitlist' } } },
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }
    }
  };

  zvWimPost('subscriptions', subPayload)
    .then(function(){
      // Consent/list membership is already accepted. Profile fields are optional.
      return zvWimPost('profiles', profPayload).catch(function(){ return true; });
    })
    .then(function(){
      // The event is optional; never let it block the confirmation.
      return zvWimPost('events', evtPayload).catch(function(){ return true; });
    })
    .then(function(){
      zvWimDone = true;
      document.getElementById('zvWimForm').style.display = 'none';
      document.getElementById('zvWimNote').style.display = 'none';
      document.getElementById('zvWimOk').classList.add('show');
      try { if (typeof window.fbq === 'function') { if (window.ZVAM && typeof window.ZVAM.lead === 'function') { window.ZVAM.lead({}, { email: email }); } else { window.fbq('track','Lead'); } } } catch (ignore) {}
    })
    .catch(function(){
      if (zvWimDone) return;
      zvWimBusy = false;
      b.disabled = false; b.textContent = 'Join the waitlist';
      zvWimSay('Something went wrong. Please try again.');
    });
}

document.addEventListener('keydown', function(e){
  if (e.key === 'Enter' && document.activeElement && document.activeElement.id === 'zvWimEmail') zvWimJoin();
});

;

// Market-aware price. Do not type a figure into this page again.
// First paint uses the map so there is no flicker, then the live product price
// overwrites it, so a price change in Shopify reaches this page on its own.
(function(){
  var SYMBOL = { USD:'$', GBP:'£', EUR:'€' };
  var FIRST_PAINT = { USD:6900, GBP:4900 };
  var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function fmt(cents){
    var v = cents / 100;
    return (SYMBOL[code] || code + ' ') + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function paint(cents){
    window.ZV_PRICE = fmt(cents);
    var n = document.querySelectorAll('.zv-price-auto');
    for (var i = 0; i < n.length; i++) n[i].textContent = window.ZV_PRICE;
  }
  if (FIRST_PAINT[code]) paint(FIRST_PAINT[code]);
  fetch('/products/the-pdrn-serum.js', { headers:{ 'Accept':'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){ if (p && typeof p.price === 'number') paint(p.price); })
    .catch(function(){});
})();
